import { render, staticRenderFns } from "./audioButton.vue?vue&type=template&id=f746f9a8&scoped=true&"
import script from "./audioButton.vue?vue&type=script&lang=js&"
export * from "./audioButton.vue?vue&type=script&lang=js&"
import style0 from "./audioButton.vue?vue&type=style&index=0&id=f746f9a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f746f9a8",
  null
  
)

export default component.exports